/**
 * Проверка поддержки CSS свойства браузером.
 * @param {string} cssproperty
 * @returns {boolean} true если поддерживает
 */
export const supportsCssProperty = cssproperty => {
  let element = document.createElement('p').style
  let prefixes = ['ms', 'O', 'Moz', 'Webkit']

  if (element[cssproperty] === '') {
    return true
  }
  while (prefixes.length) {
    if (prefixes.pop() + cssproperty in element) {
      return true
    }
  }
  return false
}
